import { Card, Col, Row, Spin } from 'antd'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { EventReportKeyColumnDescription } from 'src/api/api'
import DashboardHeader from './DashboardHeader'
import Filters, { emptyFilters } from './Filters'
import HorizontalBarChart from './HorizontalBarChart'
import PerformanceChart from './PerformanceChart'
import './style.css'
import { DashboardFilters, Period, useDashboardData } from './useDashboardData'

const now = dayjs()
const startFormat = 'YYYY-MM-DD 00:00:00'
const endFormat = 'YYYY-MM-DD 23:00:00'

const KeyColumnEnum = EventReportKeyColumnDescription.ColumnEnum

const topBarTitles = {
    [KeyColumnEnum.SSP]: 'Top 10 SSPs by Cost',
    [KeyColumnEnum.MediaAgency]: 'Top 10 Media Agencies by Cost',
    [KeyColumnEnum.Advertiser]: 'Top 10 Advertisers by Cost',
    [KeyColumnEnum.Campaign]: 'Top 10 Campaigns by Cost',
    [KeyColumnEnum.AdGroup]: 'Top 10 AdGroups by Cost',
    [KeyColumnEnum.Creative]: 'Top 10 Creatives by Cost'
}

export const Dashboard = () => {

    const [screenWidth, setScreenWidth] = useState<number | null>(null)
    const [filters, setFilters] = useState<DashboardFilters>(emptyFilters())
    const [period, setPeriod] = useState<Period>(() => ({ key: KeyColumnEnum.DayHour, dates: [now.format(startFormat), now.format(endFormat)] }))

    const { performanceData, topValuesData, loading } = useDashboardData(period, filters)

    const getNames = (el: any) => el.name
    const getValues = (el: any) => el.value as number

    useEffect(() => {
        const updateWidth = () => {
            setScreenWidth(window.innerWidth)
        }

        window.addEventListener('resize', updateWidth)
        updateWidth()

        return () => window.removeEventListener('resize', updateWidth)
    }, [])

    if (screenWidth === null) return null

    return (
        <div style={{ display: 'flex', gap: '16px' }}>
            <div style={{ width: 'calc(100% - 300px)' }}>
                <Row gutter={[16, 16]}>
                    <Col span={24}>
                        <DashboardHeader
                            data={performanceData}
                            period={period}
                            setPeriod={setPeriod}
                            loading={loading}
                        />
                    </Col>
                </Row>
                <Row gutter={[16, 16]}>
                    {performanceData ? (
                        <PerformanceChart data={performanceData} period={period} loading={loading} />
                    ) : (
                        <Card style={{ borderRadius: 8, width: '100%', margin: 8, minHeight: '380px' }}>
                            <Spin
                                size="large"
                                style={{ display: 'block', margin: '20px', minHeight: '380px', alignContent: 'center' }}
                            />
                        </Card>
                    )}
                </Row>
                <Row gutter={[16, 16]} className="horizontal-bar-container">
                    <Col xs={24} md={8}>
                        <HorizontalBarChart
                            title={topBarTitles[topValuesData[0].key]}
                            labels={topValuesData[0].counters.map(getNames)}
                            data={topValuesData[0].counters.map(getValues)}
                            max={Math.max(...topValuesData[0].counters.map(getValues))}
                            loading={loading}
                            color="#232E3F"
                        />
                    </Col>
                    <Col xs={24} md={8}>
                        <HorizontalBarChart
                            title={topBarTitles[topValuesData[1].key]}
                            labels={topValuesData[1].counters.map(getNames)}
                            data={topValuesData[1].counters.map(getValues)}
                            max={Math.max(...topValuesData[1].counters.map(getValues))}
                            loading={loading}
                            color="#5E81B8"
                        />
                    </Col>
                    <Col xs={24} md={8}>
                        <HorizontalBarChart
                            title={topBarTitles[topValuesData[2].key]}
                            labels={topValuesData[2].counters.map(getNames)}
                            data={topValuesData[2].counters.map(getValues)}
                            max={Math.max(...topValuesData[2].counters.map(getValues))}
                            loading={loading}
                            color="#E9204F"
                        />
                    </Col>
                </Row>
            </div>
            <Filters setFilters={setFilters} filters={filters} />
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/component/app/dashboard/Dashboard.tsx